import { Navigate, Outlet } from 'react-router-dom'
import { useRegistrationStatus } from '../hooks/useRegistrationStatus'
import { Spinner } from '@/components/ui/spinner'

export const RegistrationAllowedRoute = () => {
  const { data, isLoading } = useRegistrationStatus()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner className="h-8 w-8" />
      </div>
    )
  }

  // fail closed — if the check errored, treat as disabled
  if (!data?.allowed) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
